class TC_FrontpageVideoSlider {
    constructor () {
        if ($('.heading-frontpage.is-guest').length) {
            this.initEvents();
        }
    }

    initEvents () {
        this.header = $('.heading-frontpage');
        this.playButton = $('.heading-content-play');
        this.currentVideo = 0;
        this.videoCover = null;
        this.loadData();
    }

    loadData () {
        let url = 'https://api.' + window.CSITE.appDomain + '/header.json';

        $.get(url, (data, status) => {
            if (status === 'success') {
                let result = JSON.parse(JSON.stringify(data));
                this.videoData = result.videos;
                this.videoCover = $('<div class="video-cover" style="opacity: 0;"></div>');
                this.videoCover.appendTo(this.header);
                this.showVideo(true);
                this.initPlayButton();
            }
        });
    }

    showVideo (initialLoad = false) {
        this.playButton.addClass('is-loading');
        let selectedVideo = this.videoData[this.currentVideo];

        if (this.header.find('video[data-index="' + this.currentVideo + '"]').length) {
            this.videoCover.find('video').addClass('is-hidden');
            let videoToPlay = this.header.find('video[data-index="' + this.currentVideo + '"]');
            videoToPlay.removeClass('is-hidden');
            videoToPlay[0].play();
            this.playButton.removeClass('is-loading');
            clearInterval(this.timeCheck);

            this.timeCheck = setInterval(() => {
                this.shouldPlayNextVideo();
            }, 200);
        } else {
            this.videoCover.find('video').addClass('is-hidden');

            setTimeout(() => {
                let videoURL = $(window).outerWidth() > 1040 ? selectedVideo.hd_url : selectedVideo.mobile_url;
                let video = $('<video class="video-cover-content is-hidden" data-index="' + parseInt(this.currentVideo, 10) + '" src="' + DOMPurify.sanitize(videoURL) + '" poster="https://' + window.CSITE.appDomain + '/templates/christiansite/images/header-video-thumbnail.jpg" autoplay disablePictureInPicture playsinline></video>');
                video.appendTo(this.videoCover);

                video.on('loadeddata', () => {
                    let videoPromise = video[0].play();

                    if (videoPromise !== undefined) {
                        videoPromise.then(_ => {
                            this.header.removeClass('is-loading');
                            this.playButton.removeClass('is-loading').addClass('is-playing');
                        }).catch(error => {
                            this.header.removeClass('is-loading');
                            this.playButton.removeClass('is-loading').removeClass('is-playing');
                        });
                    } else {
                        this.header.removeClass('is-loading');
                        this.playButton.removeClass('is-loading').addClass('is-playing');
                    }


                    this.currentVideoDuration = video[0].duration;
                    video.removeClass('is-hidden');
                    clearInterval(this.timeCheck);

                    this.timeCheck = setInterval(() => {
                        this.shouldPlayNextVideo();
                    }, 200);
                });

                video.on('play', () => {
                    $('.video-cover').css('opacity', 1);
                    this.playButton.addClass('is-playing');
                });

                video.on('pause', () => {
                    this.playButton.removeClass('is-playing');
                });
            }, 0);
        }
    }

    shouldPlayNextVideo () {
        let currentVideoTime = this.header.find('video[data-index="' + this.currentVideo + '"]')[0].currentTime;

        if (this.currentVideoDuration === 0) {
            this.currentVideoDuration = this.header.find('video[data-index="' + this.currentVideo + '"]')[0].duration;
        } else {
            if (this.currentVideoDuration - currentVideoTime < 1.33 && currentVideoTime !== 0) {
                clearInterval(this.timeCheck);

                setTimeout(() => {
                    this.nextVideo();
                }, 500);
            }
        }
    }

    nextVideo (videoNumber = false) {
        if (videoNumber === false) {
            this.currentVideo++;
        } else {
            this.currentVideo = videoNumber;

            clearInterval(this.timeCheck);

            setTimeout(() => {
                this.showVideo();
            }, 500);
            return;
        }

        if (this.currentVideo >= this.videoData.length) {
            this.currentVideo = 0;
        }

        this.showVideo();
    }

    initPlayButton () {
        this.playButton.on('click', () => {
            if (this.playButton.hasClass('is-loading')) {
                return;
            }

            let videoToCheck = this.header.find('video[data-index="' + this.currentVideo + '"]')[0];
            
            if (videoToCheck.paused) {
                videoToCheck.play();
            } else {
                videoToCheck.pause();
            }
        });
    }
}
